import React from "react";

export default function TrackingIcon({ color, props }) {
  return (
    <svg width={23} height={22} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.920898 11C2.5143 6.97583 6.44714 4.125 11.0523 4.125C15.6575 4.125 19.5904 6.97583 21.1838 11C19.5904 15.0242 15.6575 17.875 11.0523 17.875C6.44714 17.875 2.5143 15.0242 0.920898 11ZM19.1759 11C17.6562 7.91083 14.5431 5.95833 11.0523 5.95833C7.56158 5.95833 4.44847 7.91083 2.92875 11C4.44847 14.0892 7.55237 16.0417 11.0523 16.0417C14.5523 16.0417 17.6562 14.0892 19.1759 11ZM11.0523 8.70833C12.3234 8.70833 13.3549 9.735 13.3549 11C13.3549 12.265 12.3234 13.2917 11.0523 13.2917C9.7813 13.2917 8.74974 12.265 8.74974 11C8.74974 9.735 9.7813 8.70833 11.0523 8.70833ZM6.90766 11C6.90766 8.72667 8.76816 6.875 11.0523 6.875C13.3365 6.875 15.197 8.72667 15.197 11C15.197 13.2733 13.3365 15.125 11.0523 15.125C8.76816 15.125 6.90766 13.2733 6.90766 11Z"
        fill={color}
      />
    </svg>
  );
}
